export default __webpack_public_path__ + "static/media/photo-1531251445707-1f000e1e87d0.be76211f.jpeg";